import { collection } from '@firebase/firestore';
import firebase from 'firebase/compat/app';
import { firebaseConfig } from './firebaseconfig';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/database';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();
const storage = firebase.storage();
const database = firebase.database();

// PEGAR O ANO ATUAL
const dataAtual = new Date();
const anoAtual = dataAtual.getFullYear();
localStorage.setItem('ano', anoAtual);
const ANO = localStorage.getItem('ano');

const lerNotificacaoComoResponsavel = async (responsavel, serie) => {
    return new Promise((resolve, reject) => {
      const notifications = [];
  
      try {
        const notificationsRef = database.ref(`${ANO}/notification/${responsavel}`);
  
        notificationsRef.limitToLast(20).on('child_added', (snapshot) => {
          const notificationId = snapshot.key;
          const notification = snapshot.val();
  
          if (notification.usuario !== responsavel) {
            const notificationObj = {
              mensagem: notification.mensagem,
              hora: notification.hora,
              usuario: notification.usuario,
              id: notificationId,
              servidor: notification.servidor,
              serie: notification.serie,
            };
  
            notifications.push(notificationObj);
          }
        });
  
        // Quando todas as notificações forem adicionadas, resolve a Promise com o array de notificações
        notificationsRef.on('value', () => {
          resolve(notifications);
        });
      } catch (error) {
        reject(error);
        console.error('Erro ao obter notificações:', error);
      }
    });
  };
  
  
  const lerNotificacaoComoServidor = async (servidor) => {
    return new Promise((resolve, reject) => {
      const notifications = [];
  
      try {
        const notificationsRef = database.ref(`${ANO}/notification/${servidor}`);
  
        // Limite o número de notificações recuperadas (exemplo: 10 mensagens mais recentes)
        notificationsRef.limitToLast(20).on('child_added', (snapshot) => {
          const notificationId = snapshot.key;
          const notification = snapshot.val();
  
          const notificationObj = {
            mensagem: notification.mensagem,
            hora: notification.hora,
            usuario: notification.usuario,
            id: notificationId,
            servidor: notification.servidor,
            serie: notification.serie,
          };
  
          notifications.push(notificationObj);
        });
  
        // Quando todas as notificações forem adicionadas, resolve a Promise com o array de notificações
        notificationsRef.on('value', () => {
          resolve(notifications);
        });
      } catch (error) {
        reject(error);
        console.error('Erro ao obter notificações:', error);
      }
    });
};

  
// VERIFICAR NOTIFICACAO ATIVADA
const verificarNotificacaoResponsavel = async (responsavel, serie) => {
    
    const resposta = new Promise( async (resolve, reject) => {
        
        try {
            const responsaveisSnapshot = await db.collection(ANO)
                .doc('responsaveis')
                .collection(responsavel)
                .get();
        
            responsaveisSnapshot.forEach(async (doc) => {
                const data = doc.data();
                const notificationId = data.onesignalId;
                const imagem = data.imagem;
        
                if (imagem) {
                    const imagemRef = storage.ref(`${ANO}/responsaveis/${responsavel}/${imagem}`);
                    try {
                        const metadata = await imagemRef.getMetadata();
                        
                        // Se chegou aqui, o objeto existe
                        const url = await imagemRef.getDownloadURL();
                        localStorage.setItem('imagemPerfil', url);
                    } catch (error) {
                        localStorage.removeItem('imagemPerfil');
                    }
                } else {
                    localStorage.removeItem('imagemPerfil');
                }
                if (!notificationId) {
                    resolve(false);
                }
            });

            await db.collection(ANO)
            .doc('series')
            .collection(serie)
            .doc(responsavel)
            .get().then((val) => {
                if (val.data()) {
                    const notificationId = val.data().onesignalId;
                    if (!notificationId) {
                        resolve(false);
                    }
                }
            })
    
            await resolve(true);

        } catch (error) {
            // Tratar erros
            console.error("Erro ao obter os dados:", error);
        } 
    });

    return resposta;

}

const verificarNotificacaoServidor = async (servidor, usuario) => {
    const resposta = new Promise( async (resolve, reject) => {
        await db.collection(ANO)
        .doc('restrito')
        .collection(servidor)
        .doc('login')
        .collection('acessos')
        .doc(usuario)
        .get().then( async (doc) => {
            var data = doc.data();
            if (data) {
                const imagem = data.imagem;
                if (imagem) {
                    const imagemRef = await storage.ref(`${ANO}/${servidor}/${usuario}/${imagem}`);
                    try {
                        const metadata = await imagemRef.getMetadata();
                        
                        // Se chegou aqui, o objeto existe
                        const url = await imagemRef.getDownloadURL();
                        localStorage.setItem('imagemPerfil', url);
                    } catch (error) {
                        localStorage.removeItem('imagemPerfil');
                    }
                } else {
                    localStorage.removeItem('imagemPerfil');
                }
                if (data.onesignalId) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            } else {
                resolve(false);
            }
        });
    });
    return resposta;
}


export { db, ANO, database, lerNotificacaoComoResponsavel, lerNotificacaoComoServidor, verificarNotificacaoResponsavel, verificarNotificacaoServidor };